import { render, staticRenderFns } from "./SgAttrSelect.vue?vue&type=template&id=6ec7632d&"
import script from "./SgAttrSelect.vue?vue&type=script&lang=js&"
export * from "./SgAttrSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports